export default __webpack_public_path__ + "static/media/docker.81848b7d.svg";